import FileUploadItem from 'emerald-ui/lib/FileUploadItem';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: FileUploadItem, componentName: 'FileUploadItem' }], 'FileUploadItem'),
  description: 'List item that shows information about a file.',
  codeSamples: [
    {
      title: 'Default',
      scope: { FileUploadItem },
      whiteBackground: true,
      code: `<FileUploadItem name="my-file.js" />`,
    },
  ],
};
